import { useApiQuery } from '../../hooks/useApiQuery';
import { formatDate, money } from '../../lib/format';
import { CREDIT_DELAY_DAYS, POINTS_PER_RUPEE } from '../../lib/constants';
export interface Rewards {
  balance: number;
  available_points: number;
  reserved_points: number;
  pending_points: number;
  value_paise: number;
  referral_url: string;
  policy: {
    referral_bonus_points: number;
    purchase_points_per_rupee: number;
    redemption_cap_bps: number;
  };
  ledger: { id: string; kind: string; points: number; created_at: string; available_at: string }[];
  referrals: { qualified: boolean; points: number }[];
}
export default function RewardsPage() {
  const { data, error } = useApiQuery<Rewards>('/rewards');
  return (
    <section className="account-page page-container">
      <h1>Your rewards</h1>
      {error && <p role="alert">{error}</p>}
      {data && (
        <>
          <h2>
            {data.available_points} available points · {money(data.value_paise)}
          </h2>
          <p>{data.reserved_points} points reserved for checkout. Points do not expire.</p>
          {data.pending_points > 0 && (
            <p>
              {data.pending_points} points pending. Rewards are credited {CREDIT_DELAY_DAYS} days after
              delivery.
            </p>
          )}
          {data.balance < 0 && (
            <p>Returned-order rewards have been reversed. Future earnings will offset your balance.</p>
          )}
          <p>
            Earn {data.policy.purchase_points_per_rupee} point
            {data.policy.purchase_points_per_rupee === 1 ? '' : 's'} per discounted product rupee.{' '}
            {POINTS_PER_RUPEE} points = ₹1. Use points for up to {data.policy.redemption_cap_bps / 100}% of
            discounted products.
          </p>
          <h2>Refer a friend</h2>
          <p>
            Earn {data.policy.referral_bonus_points} points after your friend's first paid order is delivered.
          </p>
          <label>
            Your referral link
            <input readOnly value={data.referral_url} onFocus={(e) => e.target.select()} />
          </label>
          <p>
            {data.referrals.filter((r) => r.qualified).length} qualified of {data.referrals.length} referrals.
          </p>
          <h2>Points history</h2>
          {data.ledger.map((l) => (
            <p key={l.id}>
              {formatDate(l.created_at)} · {l.kind} · {l.points > 0 ? '+' : ''}
              {l.points}
              {new Date(l.available_at) > new Date() && ` · available ${formatDate(l.available_at)}`}
            </p>
          ))}
        </>
      )}
    </section>
  );
}
